import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row, Table} from "react-bootstrap";
import DatePicker from "react-datepicker";
import axios from "axios";
import {Typeahead} from "react-bootstrap-typeahead";
import {BrandView} from "../Items/BrandView";
import {CategoryView} from "../Items/CategoryView";
import {formatDate, formatDateToStandard} from "../../utils";
import {number} from "prop-types";
import {types} from "sass";
import Number = types.Number;

export const InsuranceRateItemView = (props: {skuItem: any, postAction: any, insurances: Array<any>}) => {

    const [formData, setFormData] = useState<any>({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = (e) => {

        if(props.skuItem && props.skuItem.id) {
            axios.post('/api/backend/inventory/item/batch/update/'+props.skuItem.id, {
                ...formData,
                sku : formData["sku"] ? formData["sku"] : "none"
            })
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setSuccessMessage("* Data updated")
                    props.postAction()
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    setErrorMessage("* Something went wrong!")
                })
        } else {
            axios.post('/api/backend/inventory/item/batch/create', {
                ...formData,
                sku : formData["sku"] ? formData["sku"] : "none"
            })
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setSuccessMessage("* Data updated")
                    props.postAction()
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    setErrorMessage("* Something went wrong!")
                })
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    useEffect(() => {

        if(props.skuItem) {
            setFormData({...formData, ...props.skuItem});
        }
    }, [props.skuItem])


    function getItemForm() {
        return <>
            <div className="row">

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="sku">
                        <Form.Label className="fs-7 text-secondary">Sponsor<span className="text-danger">*</span></Form.Label>
                        <Form.Select className=""
                                value={formData['sku'] == "none" ? 0 : formData['sku']}
                                name="sku"
                                onChange={e => handleChange(e)}
                        >
                            <option value={0} key={0}>Self</option>
                            {props.insurances && props.insurances.map(insurance => {
                                return <option value={insurance.id} key={insurance.id}>{insurance.tpa}</option>
                            })

                            }
                        </Form.Select>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="sellingPrice">
                        <Form.Label className="fs-7 text-secondary">Cost (inclusive of taxes)<span className="text-danger">*</span></Form.Label>
                        <Form.Control onChange={handleChange} value={formData['sellingPrice']} name="sellingPrice"
                                      type="number"
                                      placeholder="Enter Price in ₹"/>
                    </Form.Group>
                </div>

                <div className="pt-5">
                    <Button className="text-white" variant="info" type="submit" onClick={handleSubmit}>
                        Save
                    </Button>
                </div>
                {successMessage &&
                    <div className="text-success fs-5">{successMessage}</div>
                }
                {errorMessage &&
                    <div className="text-danger fs-5">{errorMessage}</div>
                }
            </div>
        </>;
    }


    return (
        <>
            {getItemForm()}
        </>
    );
};
